module.exports = __webpack_public_path__ + "static/bootstrap-badge-sizes-476aac2abe07107394fb91c113b15fa3.png";